import { FunctionComponent, ReactElement, useCallback } from "react";
import { Amount } from "../../../../../../components";
import * as Domain from "../../../../../../domain";
import { colors } from "../../../../../../styles/colors";
import { Icon, Progress } from "../../../../../../ui";
import styles from "./Goal.module.scss";
import { IGoalProps } from "./types";

export const Goal: FunctionComponent<IGoalProps> = (
  props: IGoalProps
): ReactElement<IGoalProps> => {
  const { goal, onPress, ...restProps } = props;

  const doPress = useCallback(() => {
    onPress(goal);
  }, [goal, onPress]);

  return (
    <div className="col-lg-12 col-md-6 col-sm-6 bigCardCol">
      <div className="card bigCard mainBlockBg" onClick={doPress}>
        <div className="smallCard">
          <Icon
            backgroundColor={goal.color}
            className={styles.iconDefault}
            color={colors.palette.white}
            icon={goal.icon}
            size={32}
          />
          <div className="cardContent">
            <Amount
              className="cardContentValue"
              currency={goal.currency}
              value={goal.balance}
            />
            <Amount
              currency={goal.currency}
              value={goal.limitation}
              renderText={(formattedValue) => (
                <span className="cardContentLabel">{`из ${formattedValue}`}</span>
              )}
            />
          </div>
        </div>
        <Progress.Bar
          backgroundColor={Domain.Color.schemas[goal.color].lightBackground}
          color={goal.color}
          total={goal.limitation}
          value={goal.balance}
        />
        <span className="bigCardLabel">{goal.name}</span>
      </div>
    </div>
  );
};
